import * as selectors from './activity-types-selectors';

export const ActivityTypes = {
    ...selectors,
} as const;
